module.exports = __webpack_public_path__ + "img/notify-times.6791f784.svg";